module.exports = __webpack_public_path__ + "img/center_left.52a0a91d.svg";